import React from "react";
import { FAQ } from "../../components/containers";
import { SectionTitle } from "../../components/utility";
import Accordion from "../../components/utility/accordian/Accordion";

export function QueFaq({ FaqData }) {
  return (
    <section id="queFAQSection" className="que-faq">
      <div className="que-accordian-cover">
        <SectionTitle>Frequently Asked Questions</SectionTitle>
        {FaqData &&
          FaqData.map((item) => {
            return <Accordion title={item.title} content={item.answer} />;
          })}
      </div>
    </section>
  );
}
